import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';



export default function Step4() {

  return (
    <>
      <Grid container spacing={3}>
        <Grid item  xs={12} sm={2}>
            <TextField id="dateofaccident" fullWidth label="Date of Accident" />
        </Grid>
        <Grid item  xs={12}  sm={2}>
            <TextField
            id="accidentdayofweek"
            fullWidth
            label="Day of Week"
            />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="accidenttime" fullWidth label="Time AM/PM" />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={4}>
            <TextField id="accidentlocation1" fullWidth label="Location" />
        </Grid>
        <Grid item  xs={12}  sm={4}>
            <TextField
            id="accidentnear"
            fullWidth
            label="Near"
            />
        </Grid>
        <Grid item  xs={12} sm={4}>
            <TextField id="accidentcity" fullWidth label="City" />
        </Grid>
      </Grid>


        <Grid container spacing={3}>

             <Grid item  xs={12} sm={6}>
        <TextField id="accidentpolicereport" fullWidth label="Police Report?......LAPD/CHP/SHERIFF" />    
        </Grid>

        <Grid item  xs={12} sm={6}>
         <TextField id="accidentnegligentparty" fullWidth label="Negligent Party" />    
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={3}>
            <TextField id="accidentlocation2" fullWidth label="Location" />
        </Grid>
        <Grid item  xs={12}  sm={3}>
            <TextField
            id="accidentweather"
            fullWidth
            label="Weather "
            />
        </Grid>
        <Grid item  xs={12} sm={3}>
            <TextField id="accidentvisibility" fullWidth label="Visibility" />
        </Grid>
        <Grid item  xs={12} sm={3}>
            <TextField id="typeofincident" fullWidth label="Type of Accident" />
        </Grid>
      </Grid>


      <Grid container spacing={3}>
        <Grid item  xs={12} sm={12}>
            <TextField id="accidentpropertydamages" fullWidth label="Property Damages" />
        </Grid>
      </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={6}>
        <TextField id="accidentpropertydamagesamount" fullWidth label="Property Damages Amount: $" />           
        </Grid>
      </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={12}>
        <TextField id="describehowaccidentoccurred" fullWidth label="Describe how accident occurred in detail:" />           
        </Grid>
        </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={12}>
        <TextField id="statementonthescene" fullWidth label="Defendant's Statement On the Scene" />           
        </Grid>

        
      </Grid>

      


</>
    
  );

}
